import { Component, HostListener, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit {

  title = 'dgt';
  public test: string = 'sticky';
  isSticky: boolean = false;
  public route: any;

  @HostListener('window:scroll', ['$event'])

  checkScroll() {
    this.isSticky = window.pageYOffset >= 300;
  }

  public menu_show_hide: string = 'hide';
  public open: string = 'show_cls';
  public close: string = 'hide_cls';
  public footer_bool: boolean = true;
  toggle_show() {
    this.menu_show_hide = 'show';
    this.open = 'hide_cls';
    this.close = 'show_cls';
  }
  toggle_hide() {
    this.menu_show_hide = 'hide';
    this.close = 'hide_cls';
    this.open = 'show_cls';
  }

  constructor(private router: Router, private location: Location) {
    router.events.subscribe((val) => {

      //console.log(this.route = location.path())

      if ((this.route = location.path() == '/admin') || (this.route = location.path() == '/dashboard') || (this.route = location.path() == '/dashboard/erilist') || (this.route = location.path() == '/dashboard/ericount') || (this.route = location.path() == '/dashboard/eriedit')) {
        this.footer_bool = false;
      }
      else {
        this.footer_bool = true;
      }
    });
  }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0)
    });
  }

  tests() {

    this.toggle_hide();
  }


}
